import { useStorageListBadgeTemplates } from '../../../../ui/features/badge-management/hooks/useStorageListBadgeTemplates';
import { useBadgingTranslation } from '../../../../ui/hooks';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, CircularProgress, Grid, Typography } from '@mui/material';
import React from 'react';
import { sortBadgeTemplatesByOrder } from '../utils/sortBadgeTemplatesByOrder';
import { BadgeTemplatePreviewCard } from './BadgeTemplatePreviewCard';
export const BadgeTemplateList = () => {
    const { t } = useBadgingTranslation();
    const { data: badgeTemplates, isLoading } = useStorageListBadgeTemplates();
    return (React.createElement(Box, null,
        isLoading && React.createElement(CircularProgress, null),
        React.createElement(Box, { display: 'flex', flexDirection: 'column', gap: 2 },
            React.createElement(Box, { display: 'flex', gap: 1, alignItems: 'center', py: 1 },
                React.createElement(Typography, { variant: 'subtitle1' }, t('badges.badgeList.templateList')),
                React.createElement(Typography, { variant: 'body2', color: themeColors.text.subtle },
                    "(",
                    badgeTemplates ? badgeTemplates.rows.length : 0,
                    ")")),
            React.createElement(Grid, { container: true, spacing: 2 }, badgeTemplates &&
                badgeTemplates.rows.sort(sortBadgeTemplatesByOrder).map((badgeTemplate) => (React.createElement(Grid, { key: badgeTemplate.id, size: {
                        xs: 12,
                        md: 4,
                        lg: 3,
                    } },
                    React.createElement(BadgeTemplatePreviewCard, { key: badgeTemplate.id, badgeTemplate: badgeTemplate }))))))));
};
